import './index.less';
import React from 'react';
import moment from 'moment';
import MakeUp from './makeUp.jsx';
import Adjust from './adjust.jsx';
import Cancel from './cancel.jsx';
import Evaluate from './evaluate.jsx';
import FeedBack from './feedBack.jsx';
import { Modal, Select } from 'antd';
import { getAvailableTime } from '../../api/index.js';

const Option = Select.Option;
const title = {
  0: '申请补课',
  1: '申请调课',
  2: '取消',
  3: '学生点评',
  4: '老师反馈'
}

class Dialog extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      visible: false,
      type: '',
      data: '',
      date: '',
      day: '',
      time: '',
      clock: '',
      evaluate: '',
      feedback: '',
      teacher: '',
      total: '',
      defaultTime: '0',
    };
  }

  handleCancel = () => {
    this.setState({
      visible: false,
      type: '',
      data: '',
      day: '',
      time: '',
      clock: '',
      evaluate: '',
      feedback: '',
      teacher: '',
      total: '',
      defaultTime: '0',
      excellent: '',
      homework: '',
      insufficiency: '',
      translate: ''
    })
  }

  showModal = (data) => {
    this.setState({
      visible: true,
      type: data.type,
      data: data.data.course,
      day: data.data.time ? data.data.time : '',
      evaluate: data.data.evaluate ? data.data.evaluate : '',
      excellent: data.data.excellent,
      homework: data.data.homework,
      insufficiency: data.data.insufficiency,
      translate: data.data.translate
    });
  }

  changeDate = (value) => {
    this.setState({
      clock: value + ':00',
      defaultTime: value
    })
  }

  changeMonth = (value) => {
    const { data } = this.state;
    const { offset } = this.props;
    this.setState({
      date: value
    })
    getAvailableTime({
      id: data.get('teacher').get('id'),
      courseId: data.get('lesson').get('course_id'),
      date: value,
      offset: offset
    }).then(res => {
      if (res.code === 200) {
        this.setState({
          time: res.output,
          defaultTime: '0'
        })
      }
    })
  }

  refreshData = () => {
    const { data } = this.state;
    const { getCourseList } = this.props;
    getCourseList(moment(data.get('from_time').split(' ')[0]));
  }

  renderDate = (data) => {
    const arr = Object.keys(data);
    const dom = [];
    arr.map((item, i) => dom.push(<Option key={i} value={item}>{item}</Option>))
    return dom;
  }

  renderTime = (data) => {
    const dom = [];
    for (let i in data) {
      dom.push(<Option key={i} value={data[i]}>{data[i]}</Option>)
    }
    return dom;
  }

  dialog = (tp) => {
    const { offset } = this.props;
    const { evaluate, translate, excellent, homework, insufficiency } = this.state;
    let dom = '';
    const props = {
      ...this.state,
      offset: offset,
      renderTime: this.renderTime,
      renderDate: this.renderDate,
      changeDate: this.changeDate,
      changeMonth: this.changeMonth,
      refreshData: this.refreshData,
      handleCancel: this.handleCancel,
    }
    switch(tp) {
      case 0:
        dom =
        <MakeUp {...props}/>; break;
      case 1: 
        dom =
        <Adjust {...props}/>; break;
      case 2: dom = <Cancel {...props}/>; break;
      case 3: dom = <Evaluate {...props}/>; break;
      case 4: 
        const feedback = JSON.parse(evaluate.teacher_feedback)
        dom = <FeedBack data={feedback} excellent={excellent} homework={homework} insufficiency={insufficiency} translate={translate} handleCancel={this.handleCancel}/>; break;
      default: break;
    }
    return dom;
  }

  render() {
    const { visible, type } = this.state;
    return (
      <Modal
        visible={visible}
        title={title[type]}
        onCancel={this.handleCancel}
        width='600px'
        footer=''>
        {
          this.dialog(type)
        }
      </Modal>
    )
  }
}

export default Dialog


// WEBPACK FOOTER //
// ./src/components/dialog/dialog.jsx